define(
	'UC.MatchItemCellHeight.MatchItemCellHeight'
	, [
		'jQuery.matchHeight',
		'jQuery'
	]
	, function (
		matchHeight,
		jQuery
	) {
		'use strict';

		// RP 2026-10-22: match with min-height, not height, and match again as late
		// content arrives. The single pass at 950 ms fixed every cell at a pixel
		// height; images and stock messages that loaded after that spilled over
		// the next row's Add to Cart buttons and, on the last row, the footer.
		var SELECTORS = [
			'.facets-items-collection-view-cell-span3',
			'.facets-item-cell-grid-details',
			'.facets-item-cell-grid-title',
			'.facets-item-cell-table-details',
			'.facets-item-cell-table-title',
			'.custom-stock-message-container',
			'.uc-custom-information-container'
		];
		var LATER_PASSES_MS = [950, 2500, 5000];

		function matchAll() {
			// start over each pass: only this page's cells, not every page seen so far
			jQuery.fn.matchHeight._groups = [];
			for (var i = 0; i < SELECTORS.length; i++) {
				jQuery(SELECTORS[i]).matchHeight({ property: 'min-height' });
			}
		}

		return {
			mountToApp: function mountToApp(container) {
				var plp = container.getComponent('PLP');
				if (!SC.isPageGenerator()) {
					if (plp) {
						plp.cancelableOn('afterShowContent', function () {
							for (var i = 0; i < LATER_PASSES_MS.length; i++) {
								setTimeout(matchAll, LATER_PASSES_MS[i]);
							}
							// each product image that finishes loading re-matches its row
							jQuery('.facets-items-collection-view-cell-span3 img').one('load', function () {
								jQuery.fn.matchHeight._update(true);
							});
						});
					}
				}
			}
		};
	});
